import { useReducer } from 'react';
import { createReducer, IPaginationState } from 'src/utils/server-side-pagination';
import { useGetInvoicesPerClientQuery } from 'src/store/slices/invoicesAPISlice';
import { useHasPermission } from 'src/lib/hooks/useHasPermission';
import { Permission } from 'src/assets/data/permissions';

export const ROWS_PER_PAGE = 10;

export const initialState: IPaginationState = {
  filters: {
    clientId: '',
  },
  sorting: {},
  page: 1,
};

export const useGetPaginatedInvoices = (clientId: string) => {
  const canRead = useHasPermission(Permission.ReadInvoice);
  const [state, dispatch] = useReducer(createReducer({ ...initialState, filters: { clientId } }), {
    ...initialState,
    filters: { clientId },
  });

  const { data, isLoading, isFetching } = useGetInvoicesPerClientQuery(
    { state, limit: ROWS_PER_PAGE, clientId },
    { refetchOnMountOrArgChange: true, skip: !canRead }
  );

  return {
    data: data?.data ?? [],
    totalPages: data?.totalPages,
    totalItems: data?.totalItems,
    paginationPage: data?.page,
    isLoading,
    isFetching,
    ...state,
    dispatch,
  };
};
